import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["TooltipRoot"], null, {
    default: _withCtx(() => [
      _createVNode($setup["TooltipTrigger"], {
        type: "button",
        class: "tooltip__trigger"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fa-regular fa-info-circle" }, null, -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["TooltipPortal"], null, {
        default: _withCtx(() => [
          _createVNode($setup["TooltipContent"], {
            position: 'popper',
            "position-strategy": 'absolute',
            "collision-padding": { top: '20px', bottom: '20px' },
            class: "tooltip__content"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["TooltipArrow"], { class: "tooltip__arrow" }),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3 /* FORWARDED */
          })
        ]),
        _: 3 /* FORWARDED */
      })
    ]),
    _: 3 /* FORWARDED */
  }))
}